<template>
    <table class="table bg-white table-bordered">
        <tbody v-if="this.response.method !== 'Structural Similarity Index Measure'">
            <tr>
                <td>
                    <span>{{ 'Method' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.response.method }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'All' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.all }} <span v-if="this.response.method === 'Absolute Error Count'">{{ 'Pixels' | trans }}</span></span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Blue' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.blue }} <span v-if="this.response.method === 'Absolute Error Count'">{{ 'Pixels' | trans }}</span></span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Green' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.green }} <span v-if="this.response.method == 'Absolute Error Count'">{{ 'Pixels' | trans }}</span></span>
                </td>
            </tr>
            <tr>
                <td>
                    <span>{{ 'Red' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.factors.red }} <span v-if="this.response.method == 'Absolute Error Count'">{{ 'Pixels' | trans }}</span></span>
                </td>
            </tr>
            <tr v-if="showPercentDiff()" class="font-weight-bold">
                <td>
                    <span>{{ 'Difference' | trans }}</span>
                </td>
                <td>
                    <span>{{ percentDiff }}%</span>
                </td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td>
                    <span>{{ 'Method' | trans }}</span>
                </td>
                <td>
                    <span>{{ this.response.method }}</span>
                </td>
            </tr>
            <tr class="font-weight-bold">
                <td>
                    <span>{{ 'Image Similarity' | trans }}</span>
                </td>
                <td>
                    <span>{{ (this.factors.all * 100).toFixed(2) }}%</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { translate } from '../../../../helper/translate';
export default {
    name: 'ImageQualityFactorTable',
    props: {
        factors: Object,
        response: Object,
        percentDiff: String,
    },
    filters: {
        trans(msg) {
            return translate(msg);
        },
    },
    methods: {
        showPercentDiff() {
            return this.percentDiff && this.response.method === 'Absolute Error Count';
        }
    },
};
</script>
<style></style>
